import "/assets/styles/sections/home/references.scss";

// Partials
import Img from "@wearetla/tla-essentials-tools/partials/img";

// Static Assets
import image_if from '/assets/images/references/if.svg';
import image_ifsokak from '/assets/images/references/ifsokak.svg';
import image_wakeupworks from '/assets/images/references/wakeupworks.svg';
import image_blissout from '/assets/images/references/blissout.svg';
import image_event312 from '/assets/images/references/event312.svg';

const References = () => {
  return (
    <main
      id="references"
      className="section home-references">
      <div className="references-wrap wrapper">
        <h3 className="references-title">Trusted by Leading Brands</h3>

        <ul className="references-list">
          <li className="list-item">
            <a href="https://www.ifperformance.com/" target="_blank" rel="noreferrer">
              <Img
                className="item-logo"
                alt="IF Performance Hall"
                src={image_if} />
            </a>
          </li>
          <li className="list-item">
            <a href="https://www.ifperformance.com/" target="_blank" rel="noreferrer">
              <Img
                className="item-logo"
                alt="IF Sokak"
                src={image_ifsokak} />
            </a>
          </li>
          <li className="list-item">
            <a href="https://www.wakeup.works/" target="_blank" rel="noreferrer">
              <Img
                className="item-logo"
                alt="Wake Up Works"
                src={image_wakeupworks} />
            </a>
          </li>
          <li className="list-item">
            <a href="https://blissoutfestival.com/" target="_blank" rel="noreferrer">
              <Img
                className="item-logo"
                alt="Blissout"
                src={image_blissout} />
            </a>
          </li>
          <li className="list-item">
            <a href="https://www.event312.com/" target="_blank" rel="noreferrer">
              <Img
                className="item-logo"
                alt="Event312"
                src={image_event312} />
            </a>
          </li>
        </ul>
      </div>
    </main>
  );
};

export default References;
